<template>
  <div class="background-container">
    <div class="blurry-background"></div>
    <h1>nai3中转平台</h1>
    <el-card class="box-card">
      <h2>登录</h2>
      <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-position="left"
          label-width="100px"
          class="login-form"
      >
        <el-form-item label="用户名" prop="account">
          <el-input v-model="ruleForm.account"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
              type="password"
              v-model="ruleForm.password"
              autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btnGroup">
        <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            :loading="loading"
        >登录</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      ruleForm: {
        account: "",
        password: "",
      },
      rules: {
      },
      loading: false,
    };
  },
methods: {
  async submitForm(formName) {
    try {
      await this.$refs[formName].validate();
      this.loading = true;

      // Send login request using axios
      const response = await axios.post("/api/admin/login", {
        account: this.ruleForm.account,
        password: this.ruleForm.password,
      });

      if (response.data.code === 200) {
        // If login is successful, set token in cookie and navigate to /home
        this.$cookies.set('token', response.data.data, '1D');
        sessionStorage.setItem("userInfo", JSON.stringify(response.data.data));
        await this.$router.push('/home');
        this.$message({
          message: "登录成功",
          type: "success",
        });
      } else {
        this.$message({
          message: response.data.msg,
          type: "warning",
        });
      }
    } catch (error) {
      console.error("提交表单时出错：", error);
    } finally {
      this.loading = false;
    }
  },
  resetForm(formName) {
    this.$refs[formName].resetFields();
  },
},
};
</script>


<style>
.background-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.blurry-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background-image: url(../assets/001.png);*/
  background-size: cover;
  /*filter: blur(5px);*/
  z-index: -1;
}

h1 {
  padding: 10px;
  color: white;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

label {
  margin-bottom: 10px;
  color: white;
}

input[type="text"],
input[type="password"] {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  width: 230px;
  outline: none; /* 去除输入框的默认外边框 */
}

button[type="submit"] {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}
</style>